import { Box, Slider as NBSlider, usePropsResolution } from 'native-base';
import { DragAndDropOutlined } from '../Icon';
import React from 'react';
import type { LayoutChangeEvent } from 'react-native';
import type { ISliderProps } from './Slider.types';
import { getThumbPercent } from './Slider.utils';

export const Slider: React.FunctionComponent<ISliderProps> = ({
  thumbLabel,
  ...props
}) => {
  const { _icon } = usePropsResolution('SliderThumb', props);
  const { _wrapper, _label } = usePropsResolution('Slider', props);

  const [textWidth, setTextWidth] = React.useState(100);
  const onLayout = (event: LayoutChangeEvent) => {
    const { width } = event.nativeEvent.layout;
    setTextWidth(width);
  };

  const [thumbLeft, setThumbLeft] = React.useState(
    `${getThumbPercent(props.defaultValue, props.minValue, props.maxValue)}%`
  );
  const onChange = (value: number) => {
    setThumbLeft(`${getThumbPercent(value, props.minValue, props.maxValue)}%`);
    props.onChange?.(value);
  };

  return (
    <Box {..._wrapper}>
      <NBSlider {...props} onChange={onChange}>
        <NBSlider.Track>
          <NBSlider.FilledTrack
            // @ts-ignore
            variant={props.variant}
          />
        </NBSlider.Track>
        <NBSlider.Thumb>
          <DragAndDropOutlined size={5} {..._icon} />
        </NBSlider.Thumb>
      </NBSlider>
      {thumbLabel && (
        <Box
          left={thumbLeft}
          onLayout={onLayout}
          style={{ transform: [{ translateX: -textWidth / 2 }] }}
          {..._label}
        >
          {thumbLabel}
        </Box>
      )}
    </Box>
  );
};
